import { Box, Button } from "./styles";

export interface ActionBoxProps {
	onClick: () => void;
	className?: string;
}

export const ActionBox = ({ onClick, className = "" }: ActionBoxProps) => (
	<Box className={className}>
		<Button
			className={className}
			variant="contained"
			themeColor="primary"
			onClick={onClick}
		>
			Enable
		</Button>
	</Box>
);
